import {
  accountColumnDefinition,
  adjustmentTypeColumnDefinition,
  amountFromColumnDefinition,
  annualCumulative,
  balanceColumnDefinition,
  bookToTaxCodeDescriptionColumnDefinition,
  descriptionColumnDefinition,
  disallowedAmountColumnDefinition,
  manualAmountColumnDefinition,
  multiplierColumnDefinition,
  oneByOneBalanceColumnDefinition,
  recurrenceFrequency,
  ytdAmountColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  methodColumnDefinition,
} from '../columnDefinitions';

export const adjustmentsColumnCollectionDefs = [
  {
    ...countryTaxTypeDescriptionColumnDefinition,
    headerName: 'Country Tax Type',
  },
  adjustmentTypeColumnDefinition,
  descriptionColumnDefinition,
  amountFromColumnDefinition,
  accountColumnDefinition,
  { ...oneByOneBalanceColumnDefinition },
  {
    ...ytdAmountColumnDefinition,
    headerName: 'Account Based YTD Balance',
    minWidth: 130,
  },
  balanceColumnDefinition,
  multiplierColumnDefinition,
  disallowedAmountColumnDefinition,
  manualAmountColumnDefinition,
  recurrenceFrequency,
  annualCumulative,
  methodColumnDefinition,
  bookToTaxCodeDescriptionColumnDefinition,
];
